import PostsMetaModel from "./PostsMetaModel";
import PostByIdFullModel from "./PostByIdFullModel";

export default class PostsFullModel {
  public meta: PostsMetaModel = new PostsMetaModel();
  public data: PostByIdFullModel[] = [];
}
